<template>
  <div>
      <Head :title="__(title)" />
    <div class="max-w-3xl overflow-hidden bg-white rounded-md shadow">
      <form @submit.prevent="update">
          <div class="flex flex-wrap p-8 -mb-8 -mr-6">
              <!-- <select-input v-if="!form.parent_id" v-model="form.department_id" :error="form.errors.department_id" class="w-full pb-8 pr-6" :label="__('Departement')">
                  <option :value="null">None</option>
                  <option v-for="s in departments" :key="s.id" :value="s.id">{{ s.name }}</option>
              </select-input>
              <select-input v-if="!form.department_id" v-model="form.parent_id" :error="form.errors.parent_id" class="w-full pb-8 pr-6" :label="__('Parent')">
                  <option :value="null">None</option>
                  <option v-for="s in categories" :key="s.id" :value="s.id">{{ s.name }}</option>
              </select-input> -->
              <text-input v-model="form.name" :error="form.errors.name" class="w-full pb-8 pr-6 " label="Nom" />
<!--              <text-input v-model="form.color" :error="form.errors.color" class="w-full pb-8 pr-6 lg:w-1/2" label="Color" />-->
          </div>
        <div class="flex items-center px-8 py-4 border-t border-gray-100 bg-gray-50">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Supprimer</button>
          <loading-button :loading="form.processing" class="ml-auto btn-indigo" type="submit">Mettre à jour</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Link, Head } from '@inertiajs/vue3'
import SelectInput from "../../Shared/SelectInput.vue";

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
      SelectInput,
    LoadingButton,
    TextInput,
      Link,
      Head,
  },
  layout: Layout,
  props: {
    title: String,
    category: Object,
      categories: { required: false },
      departments: { required: false },
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
          name: this.category.name,
          color: this.category.color,
          department_id: this.category.department_id,
          parent_id: this.category.parent_id,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('categories.update', this.category.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this category?')) {
        this.$inertia.delete(this.route('categories.destroy', this.category.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this category?')) {
        this.$inertia.put(this.route('categories.restore', this.category.id))
      }
    },
  },
}
</script>
